import { NotFound } from '@rededor/crdsl'
import React from 'react'

import NavBar from '../../components/NavBar'
import { DivMargin } from './components'

const PaginaNaoEncontrada = ({ ...props }) => (
  <div {...props}>
    <NavBar />
    <DivMargin />

    <NotFound href="/paciente/marcar-consulta" />
  </div>
)

export default PaginaNaoEncontrada
